import { render, staticRenderFns } from "./ProductListEditor.vue?vue&type=template&id=c89b8410&scoped=true"
import script from "./ProductListEditor.vue?vue&type=script&lang=ts"
export * from "./ProductListEditor.vue?vue&type=script&lang=ts"
import style0 from "./ProductListEditor.vue?vue&type=style&index=0&id=c89b8410&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89b8410",
  null
  
)

export default component.exports